// Services.jsx
import React, { useEffect, useState } from 'react';
import './Services.css';

const Services = ({ darkmodeClass }) => {

  const [activeSection, setActiveSection] = useState('');

  const handleItemClick = (sectionClass) => {
    setActiveSection(sectionClass);


    const sectionElement = document.querySelector(`.${sectionClass}`);
    if (sectionElement) {
      let scrollToPosition;

      // Adjust the scroll position based on screen size
      if (window.innerWidth <= 768) {
        // Small screen
        scrollToPosition = sectionElement.getBoundingClientRect().top + window.scrollY - 300;
      } else {
        // Large screen
        scrollToPosition = sectionElement.getBoundingClientRect().top + window.scrollY - 100;
      }

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }
  };



  return (
    <div className={`services-container ${darkmodeClass}`}>
      <div className={`sidebar ${darkmodeClass}`}>
        <h2>Our Services</h2>
        <ul className='sideul'>
          <li className={`li1 ${darkmodeClass} ${activeSection === 'general-section' ? 'active' : ''}`} onClick={() => handleItemClick('general-section')}>General Information</li>
          <li className={`li2 ${darkmodeClass} ${activeSection === 'license-section' ? 'active' : ''}`} onClick={() => handleItemClick('license-section')}>Content License Summary</li>
          <li className={`${darkmodeClass} ${activeSection === 'terms-container' ? 'active' : ''}`} onClick={() => handleItemClick('terms-container')}>Pixabay Terms of Service</li>
        </ul>
      </div>

      <div className={`content-container ${darkmodeClass}`}>
        <div className='services-div'>
          <h1 className={`services-header  ${darkmodeClass}`}>Pixabay Services</h1>
        </div>

        <div className={`general-section ${darkmodeClass} ${activeSection === 'general-section' ? 'active' : ''}`}>
          <div className='generaldiv'><h2 className='generalinfo'>General Information</h2></div>
          <ul>
            <li>
              <h3>What is Pixabay?</h3>
              <p>Pixabay is a vibrant community of creatives, sharing royalty-free HD photos and stock images, new illustration vectors, high-quality videos, popular animated GIFs, and best audio music that are free to download. All contents are released under the Pixabay License, which makes them safe to use without attribution - even for commercial purposes.</p>
            </li>
            <li>
              <h3>How can I upload photos, videos, music, etc. on Pixabay?</h3>
              <p>To upload photos, videos, music, illustrations, GIFs, sound-effects and vectors,, you need to be a registered user on Pixabay first. If you are not yet registered, you can sign up here. Once you have signed up you can upload any media by clicking the "upload” button in the top right corner of the page.</p>
            </li>
            <li>
              <h3>Can I use your photos, videos, music, illustrations, GIFs and other media? </h3>
              <p>You can copy, modify, distribute, and use the Pixabay's royalty-free stock photos, illustrations, videos, music, GIFs, vectors and sound effects, even for commercial purposes. However, depicted content may still be protected by trademarks, publicity or privacy rights.</p>
            </li>
            <li>
              <h3>Are all photos, videos, music, illustrations, GIFs and other media on Pixabay free to use?</h3>
              <p>Pixabay photos, illustrations, videos, music, animated GIFs, vectors and sound effects are free to use for commercial and non-commercial purposes. However, depicted content may still be protected by trademarks, publicity or privacy rights. While no payment is needed to use the media, it is always appreciated when you credit the contributor as it provides exposure to their work and encourages them to continue sharing. While not required, we also allow users to make donations to contributors. Find out how below under Downloads and Donations.</p>
            </li>
            <li>
              <h3>How can I download images, videos, music, and other media from Pixabay?</h3>
              <p>To download any media (stock photos, illustrations, videos, music, animated GIFs, vectors and sound effects), go to the specific media page of the content that you want to download, then click the ‘Free Download' button. Choose the size and click ‘Download'. You will need to sign up to download full resolution photos and videos,</p>
            </li>
          </ul>
        </div>

        <div className={`license-section ${darkmodeClass} ${activeSection === 'license-section' ? 'active' : ''}`}>
          <h2>Content License Summary</h2>
          <p>Welcome to Pixabay! Pixabay is a vibrant community of authors, artists and creators sharing royalty-free images, video, audio and other media. We refer to this collectively as "Content". By accessing and using Content, or by contributing Content, you agree to comply with our Content License.</p>

          <h4>What are you allowed to do with Content?</h4>
          <p>Subject to the Prohibited Uses (see below), the Content License allows users to:</p>
          <ul>
            <li>Use Content for free</li>
            <li>Use Content without having to attribute the author (although giving credit is always appreciated by our community!)</li>
            <li>Modify or adapt Content into new works</li>
          </ul>

          <h4>What are you not allowed to do with Content?</h4>
          <p>We refer to these as Prohibited Uses which include:</p>
          <ul>
            <li>You cannot sell or distribute Content (either in digital or physical form) on a Standalone basis. Standalone means where no creative effort has been applied to the Content and it remains in substantially the same form as it exists on our website.</li>
            <li>You cannot use Content in any immoral or illegal way, especially Content which features recognizable people.</li>
            <li>You cannot use Content in a misleading or deceptive way.</li>
          </ul>
          <p>Please be aware that certain Content may be subject to additional intellectual property rights (such as copyrights, trademarks, design rights), moral rights, proprietary rights, property rights, privacy rights or similar. It is your responsibility to check whether you require the consent of a third party or a license to use Content.</p>
        </div>

        <div className={`terms-container ${darkmodeClass} ${activeSection === 'terms-container' ? 'active' : ''}`}>
          <h2 className="terms-header">Pixabay Terms of Service</h2>
          <p>Last updated: April 4, 2023</p>

          <section>
            <h3>1. The basics.</h3>
            <p>
              Welcome to Pixabay! Pixabay is a vibrant community of creatives sharing royalty-free content. These Terms of Service ("Terms") apply to the pixabay.com website, related websites, software, mobile apps, plug-ins and other Pixabay-operated services (collectively, the "Service(s)").
            </p>
          </section>

          <section>
            <h3>2. Content.</h3>
            <p>
              In these Terms when we refer to "Content" we are referring to the content which is available on the Services. Content includes, but isn’t limited to the following items:
            </p>
            <ul>
              <li>"Images", which means photographs, vector graphics, drawings and illustrations.</li>
              <li>"Videos", which means moving images, animations, film footage and other audio-visual representations and content.</li>
              <li>"Audio", which means music, sounds, sound effects and other audio representations and content.</li>
              <li>"Other Media", which means any other media or content which is visual or audio in nature, or a combination of these.</li>
            </ul>
          </section>

          <section>
            <h3>3. CC0 License</h3>
            <p>
              Some of the Content made available for download on the Service is subject to and licensed under the Creative Commons Zero (CC0) license ("CC0 Content"). CC0 Content on the Service is any content which lists a "Published date" prior to January 9, 2019.
            </p>
          </section>

          <section>
            <h3>4. Content License granted to you for Content (other than CC0 Content).</h3>
            <p>
              Subject to the Prohibited Uses described below (which you agree and acknowledge you are not entitled to engage in), when you download any Content that is not CC0 Content from the Services, we grant you an irrevocable, worldwide, non-exclusive and royalty-free right to download, use, copy, modify or adapt the Content for commercial or non-commercial purposes (Content License).
            </p>
            <ol>
              <li>You agree and acknowledge that the following items are "Prohibited Uses" and the Content License which we grant to you is conditional on you not engaging in any of the Prohibited Uses.</li>
              <li>You cannot sell or distribute the Content (either in digital or physical form) on a Standalone basis.</li>
              <li>When we refer to "Standalone" we mean where no creative effort has been applied to the Content and it remains in substantially the same form as it exists on the Services.</li>
            </ol>
          </section>

          <section>
            <h3>5. Attribution.</h3>
            <p>
              You do not need to credit Pixabay or the contributor of Content when you use it, but it is certainly appreciated when you do so - especially when the use is of an editorial nature, where photo credits are more customary.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Services;
